import CustomerInfo from './CustomerInfo';

export default CustomerInfo;
